import React from 'react';
import { object } from 'prop-types';
import _ from 'underscore';
import FieldPropType from './BannerTemplateFieldPropType';

import { FormFeedback, FormGroup, Input, Label } from 'reactstrap';

const BannerLayerSourceFormTextInput = ({ field, inputProps }) => {
  const renderFeedBack = () => {
    const validationConstraint = field.validationConstraints;
    if (validationConstraint.minLength >= 1 && _.isEmpty(inputProps.value)) {
      return <FormFeedback>Uh oh! {field.label} is required.</FormFeedback>;
    }
    return (
      <FormFeedback>{`Uh oh, you are over the character limit`}</FormFeedback>
    );
  };
  return (
    <FormGroup>
      <Label
        id={`dyn_field_${field.key}Label`}
        htmlFor={`dyn_field_${field.key}`}
      >
        {field.label}
      </Label>
      <Input
        data-testid={`dyn_field_${field.key}Input`}
        id={`dyn_field_${field.key}`}
        aria-labelledby={`dyn_field_${field.key}Label`}
        {...inputProps}
        required
      />
      {inputProps.invalid && renderFeedBack()}
    </FormGroup>
  );
};

BannerLayerSourceFormTextInput.propTypes = {
  field: FieldPropType,
  inputProps: object
};

export default BannerLayerSourceFormTextInput;
